// @ts-nocheck
import React from "react";
import useAuth from '../../hooks/useAuth';
import { useTranslation } from "react-i18next";
import { Divider, List, Typography, Card, Flex, Carousel, ConfigProvider, Image } from 'antd';
import StoreList from "../../components/StoreList";
import GalleryVideoImg from "../../components/GalleryVideoImg";
import { Translate } from "../../services/translate";
import '../../styles/terms.css';

const TLSRotina = () => {

	window.scrollTo(0, 0);

	const { t, i18n: { changeLanguage, language } } = useTranslation();
	const { auth, habRoles } = useAuth();

	const hab_func = habRoles([]);

	const gallery_list = [
		{
			"link": "/img/apps/rotina_01.jpg",
			"video": false
		},
		{
			"link": "/img/apps/rotina_02.jpg",
			"video": false
		},
		{
			"link": "/img/apps/rotina_03.jpg",
			"video": false
		},
		{
			"link": "/img/apps/rotina_04.jpg",
			"video": false
		},
		{
			"link": "/img/apps/rotina_05.jpg",
			"video": false
		},
		{
			"link": "/img/apps/rotina_06.jpg",
			"video": false
		}
	];

	return (
		<div>
			<h2 className="title is-1">TLS Rotina</h2>
			<br />
			<hr />
			<br />
			<StoreList
				//chrome_store={"https://chromewebstore.google.com/detail/ggogoinhjigamdpkogcjgkmlgcknlflb/preview?hl=pt-BR&authuser=1&pli=1"} 
				google_play={"https://play.google.com/store/apps/details?id=com.tlsengenharia.minharotina"}
				apple_store={"https://apps.apple.com/br/app/tls-rotina/id6775069003"}
				microsoft_store={""}
				download={""}
				hab_download={hab_func}
				user={auth?.user}
			/>
			<br />
			<div style={{ width: "100%" }}>
				<div style={{ maxWidth: 903, margin: "auto" }}>
					<GalleryVideoImg gallery_list={gallery_list} />
				</div>
			</div>
			<br />
			<br />
			<Flex wrap gap="middle" justify="center" align="center">
				<List
					style={{ maxWidth: 1200 }}
					size="large"
					header={<h2 className="title is-1">{t('visao_geral')}</h2>}
					bordered
					dataSource={[<></>]}
					renderItem={(item: any) => <List.Item>{
						language == "pt-BR" ?
							(
								<>
									<div className='term_just'>
										Transforme sua rotina em uma jornada de evolução com o <strong>TLS Rotina</strong>!<br />
										Organize tarefas, desenvolva hábitos positivos e aumente sua produtividade através de um sistema de gamificação que torna cada conquista ainda mais motivadora.
										<br />
										<br />
										Complete atividades, acumule XP, avance de nível e acompanhe sua evolução diariamente de forma simples e envolvente.
										<br />
										<br />
										<h3>Recursos:</h3><br />
										<ul>
											<li><strong>Gerenciamento de Tarefas:</strong> Organize suas atividades diárias e mantenha o foco nos seus objetivos.</li>
											<li><strong>Sistema de XP:</strong> Ganhe experiência ao concluir tarefas e acompanhe seu progresso.</li>
											<li><strong>Progressão por Níveis:</strong> Evolua continuamente conforme mantém sua consistência.</li>
											<li><strong>Notificações e Lembretes:</strong> Receba alertas inteligentes para não esquecer compromissos importantes.</li>
											<li><strong>Controle de Hábitos:</strong> Crie e acompanhe hábitos que contribuem para seu crescimento pessoal.</li>
											<li><strong>Histórico de Conquistas:</strong> Visualize tudo o que já realizou e acompanhe sua evolução ao longo do tempo.</li>
											<li><strong>Acompanhamento de Desempenho:</strong> Monitore sua produtividade e identifique oportunidades de melhoria.</li>
											<li><strong>Interface Moderna:</strong> Design simples, intuitivo e agradável para o uso diário.</li>
										</ul>
										<br />
										Seja para estudos, trabalho, exercícios físicos, leitura ou metas pessoais, o TLS Rotina ajuda você a criar consistência e transformar pequenas ações em grandes resultados.
										<br />
										<br />
										Baixe agora e comece sua evolução diária!
									</div>
								</>
							)
							:
							language == "es" ?
								(
									<div className='term_just'>
										Transforma tu rutina en un camino de crecimiento con <strong>TLS Rotina</strong>.<br />
										Organiza tareas, desarrolla hábitos positivos y aumenta tu productividad mediante un sistema de gamificación que convierte cada logro en una nueva motivación.
										<br />
										<br />
										Completa actividades, gana XP, sube de nivel y sigue tu progreso diario de forma sencilla y atractiva.
										<br />
										<br />
										<h3>Funciones:</h3><br />
										<ul>
											<li><strong>Gestión de Tareas:</strong> Organiza tus actividades diarias y mantén el enfoque en tus objetivos.</li>
											<li><strong>Sistema de XP:</strong> Gana experiencia al completar tareas y sigue tu progreso.</li>
											<li><strong>Progresión por Niveles:</strong> Avanza constantemente a medida que mantienes tus hábitos y productividad.</li>
											<li><strong>Notificaciones y Recordatorios:</strong> Recibe alertas inteligentes para no olvidar actividades importantes.</li>
											<li><strong>Control de Hábitos:</strong> Crea y monitorea hábitos que contribuyan a tu desarrollo personal.</li>
											<li><strong>Historial de Logros:</strong> Consulta todo lo que has conseguido y observa tu evolución.</li>
											<li><strong>Seguimiento del Rendimiento:</strong> Analiza tu productividad e identifica oportunidades de mejora.</li>
											<li><strong>Interfaz Moderna:</strong> Diseño simple, intuitivo y agradable para el uso diario.</li>
										</ul>
										<br />
										Ya sea para estudios, trabajo, ejercicio, lectura o metas personales, TLS Rotina te ayuda a crear constancia y convertir pequeñas acciones en grandes resultados.
										<br />
										<br />
										¡Descárgalo ahora y comienza tu evolución diaria!
									</div>
								)
								:
								(
									<div className='term_just'>
										Transform your daily routine into a journey of growth with <strong>TLS Rotina</strong>!<br />
										Organize tasks, build positive habits, and boost your productivity through a gamification system designed to make every achievement more rewarding.
										<br />
										<br />
										Complete activities, earn XP, level up, and track your progress every day in a simple and engaging way.
										<br />
										<br />
										<h3>Features:</h3><br />
										<ul>
											<li><strong>Task Management:</strong> Organize your daily activities and stay focused on your goals.</li>
											<li><strong>XP System:</strong> Earn experience points by completing tasks and monitor your progress.</li>
											<li><strong>Level Progression:</strong> Advance through levels as you maintain consistency and productivity.</li>
											<li><strong>Smart Notifications & Reminders:</strong> Receive helpful alerts so you never miss important activities.</li>
											<li><strong>Habit Tracking:</strong> Create and monitor habits that contribute to your personal growth.</li>
											<li><strong>Achievement History:</strong> Review everything you've accomplished and track your evolution over time.</li>
											<li><strong>Performance Monitoring:</strong> Analyze your productivity and identify areas for improvement.</li>
											<li><strong>Modern Interface:</strong> Simple, intuitive, and visually appealing design for everyday use.</li>
										</ul>
										<br />
										Whether for studying, work, exercise, reading, or personal goals, TLS Rotina helps you build consistency and turn small actions into meaningful results.
										<br />
										<br />
										Download now and start your daily evolution!
									</div>
								)
					}
					</List.Item>}
				/>
			</Flex>
		</div>
	);
}


export default TLSRotina